import type { EnqueueSnackbar, VariantType } from "notistack";

export const CustomMessage = (
  message: string,
  type: VariantType,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  // Original JS was `autoHideDuration: [...].includes(type) && 3000` which yields `false` when
  // type doesn't match. Changed to `undefined` to satisfy notistack's `number | null | undefined`
  // typing — notistack treats both as "fall back to default", so behavior is preserved.
  enqueueSnackbar(message, {
    variant: type,
    persist: ["success", "info", "error"].includes(type) ? false : true,
    autoHideDuration: ["success", "info", "error"].includes(type) ? 3000 : undefined,
  });
};

export const ErrorImage = (
  message: string,
  type: VariantType,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorTiffImage = (
  message: string,
  type: VariantType,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorPdf = (
  message: string,
  type: VariantType,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};

export const ErrorInvalidFiles = (
  message: string,
  type: VariantType,
  enqueueSnackbar: EnqueueSnackbar
): void => {
  enqueueSnackbar(message, {
    variant: type,
    persist: true,
    // autoHideDuration: ["success", "info","error"].includes(type) && 3000,
  });
};
